import CryptoJS from 'crypto-js';

// 随机字节生成函数
function getRandomBytes(length) {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return array;
}

// Base64 URL安全编码（去掉padding=，将+替换为-，/替换为_）
function base64RawURLEncode(data) {
  // 如果是Uint8Array，转换为普通数组
  const bytes = data instanceof Uint8Array 
    ? Array.from(data) 
    : data;
  
  // 使用CryptoJS进行base64编码
  let base64 = CryptoJS.enc.Base64.stringify(
    typeof bytes === 'string' 
      ? CryptoJS.enc.Utf8.parse(bytes)
      : CryptoJS.lib.WordArray.create(bytes)
  );
  
  // 转换为URL安全格式
  return base64
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}

// SHA-256哈希函数
function sha256Hash(data) {
  // 如果是Uint8Array，转换为WordArray
  const input = data instanceof Uint8Array 
    ? CryptoJS.lib.WordArray.create(data)
    : data;
  
  // 计算SHA-256哈希
  const hash = CryptoJS.SHA256(input);
  return hash;
}

// 生成PKCE挑战码和验证器
export function getChallenge() {
  const seed = getRandomBytes(32);
  const verifier = base64RawURLEncode(seed);
  const challenge = base64RawURLEncode(sha256Hash(seed));
  return { verifier, challenge };
}